import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

/** Unread inbox count for the menu badges. Refreshes on every navigation and on inbox actions. */
@Injectable({ providedIn: 'root' })
export class UnreadMessagesService {
  readonly count = signal(0);

  constructor(private http: HttpClient, router: Router) {
    router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(() => this.refresh());
  }

  refresh(): void {
    if (!localStorage.getItem('appToken')) { this.count.set(0); return; }
    this.http.get<{ read: boolean }[]>(`${environment.apiUrl}/external/messages`).subscribe({
      next: (m) => this.count.set((m ?? []).filter(x => !x.read).length),
      error: () => {},
    });
  }
}
